import Navbar  from "../components/NavBar/NavBar.js";
import Spinner from "../components/Home/Spinner.js";
import Section1 from "../components/Contact/Section1.js";
import Footer from "../components/Home/Footer.js"
import Whatsapp from "../components/Home/Whatsapp.js";
import { useEffect } from "react";


const Contact = () =>{
    useEffect(() => {
  document.title =
    "UNIK SYSTEM | Contact & Informations";

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "Contactez UNIK SYSTEM pour vos projets architecturaux et techniques. Conseil, étude personnalisée et accompagnement professionnel."
    );
  }
}, []);

    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Section1/>
            <Whatsapp/>
            <Footer/>
        </div>    
    )
};

export default Contact;